var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 15 15" }, props),
    React.createElement("path", { className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-status-error"] || "oc-icon-status-error"), d: "M8.9 11.9c.1.1.1.4 0 .5l-1.3 1.3c-1.7 1.7-4.6 1.7-6.3 0-1.7-1.7-1.7-4.6 0-6.3l1.3-1.3c.1-.1.4-.1.5 0l1.2 1.2c.1.1.1.4 0 .5L3 9.1c-.8.8-.8 2.2 0 3 .8.8 2.2.8 3 0l1.3-1.3c.1-.1.4-.1.5 0l1.1 1.1zM7.3 4.3c.1.1.4.1.5 0L9.1 3c.8-.8 2.2-.8 3 0 .8.8.8 2.2 0 3l-1.3 1.3c-.1.1-.1.4 0 .5L12 9s.3 0 .4-.1l1.3-1.3c1.7-1.7 1.7-4.6 0-6.3C12-.4 9.1-.4 7.4 1.3L6.1 2.6c-.1.1-.1.4 0 .5l1.2 1.2zm6.8 10.5l.7-.7c.3-.3.3-.7 0-1L1.9.2c-.3-.3-.7-.3-1 0L.2.9c-.3.3-.3.7 0 1l12.9 12.9c.3.3.8.3 1 0z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Unmatched.svg